<button
  mat-raised-button
  color="primary"
  class="full-width"
  (click)="viewSnapshot()"
  [trackEvent]="{
    eventName: 'scorecard-open-full-report',
    category: trackingProperties?.category,
    properties: { snapshotId: trackingProperties?.snapshotId }
  }"
>
  {{ 'CTA.VIEW_REPORT' | translate }}
</button>
<button
  *ngIf="snapshotURL && showEditButton"
  mat-stroked-button
  class="full-width"
  (click)="editSnapshot()"
  [trackEvent]="{
    eventName: 'scorecard-open-edit-report',
    category: trackingProperties?.category,
    properties: { snapshotId: trackingProperties?.snapshotId }
  }"
>
  {{ 'CTA.EDIT_REPORT' | translate }}
</button>
<button
  *ngIf="enableURLCopy && snapshotURL"
  mat-stroked-button
  class="full-width"
  [cdkCopyToClipboard]="snapshotURL"
  [trackEvent]="{
    eventName: 'scorecard-copy-url',
    category: trackingProperties?.category,
    properties: { snapshotId: trackingProperties?.snapshotId }
  }"
>
  {{ 'CTA.COPY_URL' | translate }}
  <mat-icon>content_copy</mat-icon>
</button>
